import { ArrowRightLeft, DollarSign, LayoutDashboard, Mail, Package, ShoppingCart, Users, Wrench } from "lucide-react";
import type { InventoryPermissionFlags } from "@/features/inventory/hooks/useInventoryPermissions";

type InvPermFlag = keyof InventoryPermissionFlags | "ALWAYS";

interface InventoryTabDef {
  key: string;            // valor de ?subTab=
  label: string;
  flag: InvPermFlag | InvPermFlag[];
}

export interface InventorySectionDef {
  id: string;             // valor de ?tab= e sectionId das áreas
  title: string;
  defaultOpen?: boolean;
  items: InventoryTabDef[];
}

export const INVENTORY_SUBMENU_SECTIONS: InventorySectionDef[] = [
  {
    id: "catalog",
    title: "Catálogo",
    items: [
      { key: "categories", label: "Categorias",          flag: "canListCategories" },
      { key: "services",   label: "Serviços",            flag: "canListOffers" },
      { key: "products",   label: "Modelos de Produto",  flag: "canListOffers" },
      { key: "tools",      label: "Modelos de Ferramenta", flag: ["canListOffers", "canListTools"] },
    ],
  },
  {
    id: "operation",
    title: "Operação",
    items: [
      { key: "storages_list",    label: "Armazéns",               flag: "canListStorages" },
      { key: "tools_management", label: "Patrimônio de Ferramentas", flag: "canListStockTools" },
      { key: "global_stock",     label: "Estoque Global",         flag: "canListStockBalances" },
      { key: "cargo_receipt",    label: "Receb. Cargas",          flag: "canListStocks" },
      { key: "action_history",   label: "Histórico de Ações",     flag: "canListActionHistory" },
      { key: "tool_audits",      label: "Auditorias / Inspeções", flag: "canListStockTools" },
    ],
  },
  {
    id: "loans",
    title: "Empréstimos",
    items: [
      { key: "loan-requests",     label: "Minhas Solicit.", flag: "canListSolicitations" },
      { key: "loan-dispatch",     label: "Despacho",        flag: "canListSolicitations" },
      { key: "loan-agreements",   label: "Contratos",       flag: "canListSolicitations" },
      { key: "tool-notifications",label: "Notificações",    flag: "canListStockTools" },
    ],
  },
];

export interface StorageTabDef {
  key: string;
  label: string;
  flag: InvPermFlag | InvPermFlag[];
  icon: any;
}

export const STORAGE_TABS: StorageTabDef[] = [
  { key: "overview",       label: "Visão Geral",           flag: "canListStorages",               icon: LayoutDashboard },
  { key: "products",       label: "Produtos",              flag: "canListStockBalances",          icon: Package },
  { key: "tools",          label: "Ferramentas",           flag: "canListStockTools",             icon: Wrench },
  { key: "movements",      label: "Movimentações",         flag: "canListStocks",                 icon: ArrowRightLeft },
  { key: "purchaseOrders", label: "Ordens de Compra",      flag: "canListStockPurchaseOrders",    icon: ShoppingCart },
  { key: "offerControls",  label: "Gestão de Preços",      flag: "canListStockOfferControls",     icon: DollarSign },
  { key: "solicitations",  label: "Solicitações",          flag: "canListSolicitations",          icon: Mail },
  { key: "staff",          label: "Equipe",                flag: "canListStorages",               icon: Users },
];
